<template>
  <div data-testid="wealth-heading" class="wealth-heading">
    <SkeletonLoader
      v-if="isLoading"
      data-testid="wealth-heading-loader"
      :class="`wealth-heading__loader-${size}`"
    >
      <div class="loader-head loader-item" />
      <div class="loader-title loader-item" />
      <div class="loader-subtitle loader-item" />
    </SkeletonLoader>
    <ErrorHandler
      v-else-if="hasError"
      data-testid="wealth-heading-error"
      title="Não foi possível carregar o saldo neste momento"
      description="Aguarde alguns minutos e tente novamente"
      :has-border="false"
      @retry="emitRetry"
    />
    <div v-else>
      <HeadingDisplay title="" :head="head" :subtitle="subtitle" :size="size">
        <template #title-component>
          <Money>{{ title }}</Money>
        </template>
      </HeadingDisplay>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import {
  SkeletonLoader,
  HelperViewStatus,
  HeadingDisplay,
  BaseText
} from '@warrenbrasil/nebraska-web';
import { Money } from '@/modules/common/components/Money';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { ErrorHandler } from '@/modules/common/components/ErrorHandler';

@Component({
  components: {
    SkeletonLoader,
    HelperViewStatus,
    ErrorHandler,
    HeadingDisplay,
    BaseText,
    Money
  }
})
export default class WealthHeading extends Vue {
  readonly NebraskaColors = NebraskaColors;

  @Prop({ type: String, required: true })
  readonly head!: string;

  @Prop({ type: String, required: true })
  readonly title!: string;

  @Prop({ type: String, required: true })
  readonly subtitle!: string;

  @Prop({ type: String, default: 'medium' })
  readonly size!: string;

  @Prop({ type: Boolean, default: false })
  readonly hasError!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly isLoading!: boolean;

  @Emit('retry')
  emitRetry() {}
}
</script>
<style lang="less" scoped>
.wealth-heading {
  ::v-deep.error-handler {
    padding: 0;
  }
  &__loader-medium {
    .loader-item {
      margin-bottom: @size-spacing-x150;
      border-radius: @size-radius-x100;
    }
    .loader-head {
      width: 170px;
      height: 26px;
    }
    .loader-title {
      width: 240px;
      height: 48px;
    }
    .loader-subtitle {
      width: 170px;
      height: 26px;
    }
  }

  &__loader-extra-small {
    .loader-item {
      margin-bottom: @size-spacing-x150;
      border-radius: @size-radius-x100;
    }
    .loader-head {
      width: 140px;
      height: 18px;
    }
    .loader-title {
      width: 240px;
      height: 26px;
    }
    .loader-subtitle {
      width: 140px;
      height: 18px;
    }
  }
}
</style>
